import { render, staticRenderFns } from "./portal.vue?vue&type=template&id=605c1a5d"
import script from "./portal.vue?vue&type=script&lang=js"
export * from "./portal.vue?vue&type=script&lang=js"
import style0 from "./portal.vue?vue&type=style&index=0&id=605c1a5d&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogcDialog: require('/var/app/components/LogcDialog.vue').default,InternalPortalTitleAndSubtitle: require('/var/app/components/internal-portal/TitleAndSubtitle.vue').default})
